<template>
  <div class="zvonok_order">
    <div>Входящий звонок от: {{ phone }}</div>
    <div v-if="orderid">Номер заказа: {{ orderid }}</div>
    <div v-if="statusLabel">Статус: {{ statusLabel }}</div>
    <div v-if="managerLabel">Менеджер: {{ managerLabel }}</div>
    <div v-if="orderid && sourceLabel">Источник: {{ sourceLabel }}</div>
  </div>
</template>

<script>
export default {
  props: {
    phone: String,
    orderid: String,
    managerLabel: String,
    sourceLabel: String, // Новый пропс для источника
    statusLabel: String // Статус заказа (русское название) для отдела контроля
  }
};
</script>

<style scoped>
.zvonok_order {
  font-size:12px;
}
</style>
